import { useContext } from "react";

import { DymoFrameworkContext } from "../../helpers";

export const useDymoContext = () => useContext(DymoFrameworkContext);
